import { isBitrix24Mode, openInternalRouteInContext } from './bitrixInternalNavigation'

const YOUTUBE_ID_PATTERNS = [
	/youtube(?:-nocookie)?\.com\/embed\/([^?&/]+)/i,
	/[?&]v=([^&]+)/i,
	/youtu\.be\/([^?&/]+)/i,
]

const VIMEO_ID_PATTERNS = [
	/player\.vimeo\.com\/video\/([^?&/]+)/i,
	/vimeo\.com\/(?:video\/)?([^?&/]+)/i,
]

const LOCAL_VIDEO_RE = /^\/?uploads\/videos\/[^?]+\.(mp4|webm|ogg|mov|m4v)(?:\?.*)?$/i
const DIRECT_VIDEO_RE = /\.(mp4|webm|ogg|mov|m4v|m3u8)(?:[?#].*)?$/i

const extractMatch = (patterns, value) => {
	for (const pattern of patterns) {
		const match = String(value || '').match(pattern)
		if (match?.[1]) return match[1]
	}

	return ''
}

export const normalizeMediaUrl = value => {
	const normalized = String(value || '').trim()
	if (!normalized) return ''

	if (
		normalized.startsWith('http://') ||
		normalized.startsWith('https://') ||
		normalized.startsWith('//') ||
		normalized.startsWith('blob:') ||
		normalized.startsWith('data:')
	) {
		return normalized
	}

	if (normalized.startsWith('/')) {
		return normalized
	}

	return `/${normalized.replace(/^\/+/, '')}`
}

export const extractYouTubeId = value => extractMatch(YOUTUBE_ID_PATTERNS, value)

export const extractVimeoId = value => extractMatch(VIMEO_ID_PATTERNS, value)

export const isYouTubeUrl = value => Boolean(extractYouTubeId(value))

export const isVimeoUrl = value => Boolean(extractVimeoId(value))

export const isDirectVideoUrl = value => {
	const normalized = normalizeMediaUrl(value)
	return LOCAL_VIDEO_RE.test(normalized) || DIRECT_VIDEO_RE.test(normalized)
}

export const isBitrixLaunchableMediaUrl = value =>
	isYouTubeUrl(value) || isVimeoUrl(value) || isDirectVideoUrl(value)

export const getYouTubeEmbedUrl = (value, options = {}) => {
	const videoId = extractYouTubeId(value)
	if (!videoId) return normalizeMediaUrl(value)

	const params = new URLSearchParams({
		fs: '1',
		rel: '0',
	})

	if (options.autoplay) {
		params.set('autoplay', '1')
	}

	return `https://www.youtube-nocookie.com/embed/${videoId}?${params.toString()}`
}

export const getVimeoEmbedUrl = (value, options = {}) => {
	const videoId = extractVimeoId(value)
	if (!videoId) return normalizeMediaUrl(value)

	const params = new URLSearchParams()
	if (options.autoplay) {
		params.set('autoplay', '1')
	}

	const suffix = params.toString()
	return `https://player.vimeo.com/video/${videoId}${suffix ? `?${suffix}` : ''}`
}

export const openBitrixVideoSlider = (router, payload = {}, options = {}) => {
	const src = normalizeMediaUrl(payload.url || payload.src || '')
	if (!router || !src || !isBitrix24Mode()) {
		return false
	}

	return openInternalRouteInContext(
		router,
		{
			name: 'BitrixVideoPlayer',
			query: {
				src,
				...(payload.title ? { title: String(payload.title) } : {}),
				...(payload.poster ? { poster: normalizeMediaUrl(payload.poster) } : {}),
			},
		},
		{
			title: options.title || payload.title || 'Видео',
			leftBoundary: Number.isFinite(options.leftBoundary) ? options.leftBoundary : 0,
			closeCallback: options.closeCallback,
		}
	)
}
